import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import * as graphql from '@treams/treams-network';
import { Jumbo, Tabs } from '@treams/treams-ui';

import ConnectorLogsContainer from '../settings/connectors/ConnectorLogsContainer';
import Marketplace from './Marketplace';
import ConnectorMigrationTool from './migration/ConnectorMigrationTool';
import Afas from './products/Afas';
import Employes from './products/Employes';
import GoodHabitz from './products/GoodHabitz';
import GraphqlApi from './products/GraphqlApi';
import HR2Day from './products/HR2Day';
import Hooray from './products/Hooray';
import Loket from './products/Loket';
import McpRemote from './products/McpRemote';
import Microsoft from './products/Microsoft';
import Nmbrs from './products/Nmbrs';
import SDWorx from './products/SDWorx';
import Scim from './products/Scim';
import Slack from './products/Slack';
import Styr from './products/Styr';
import VismaHRM from './products/VismaHRM';
import YouForce from './products/YouForce';
import YouServe from './products/YouServe';
import SSOSettings from './sso/SSOSettings';

export function IntegrationsTabs() {
	const { t } = useTranslation();

	const { data } = graphql.useWorkspaceConnectorQuery();
	const hasConnector = !!data?.viewer.workspace.connector;

	return (
		<Tabs.Container>
			<Tabs.Item
				title={t('settings.integrations.tab.overview.title')}
				path="/settings/integrations"
			/>
			{hasConnector && (
				<Tabs.Item title={t('settings.connectors.logs.title')} path="/settings/integrations/logs" />
			)}
			<Tabs.Item title={t('settings.connectors.sso.title')} path="/settings/integrations/sso" />
			<Tabs.Item
				title={t('settings.connectors.ssoLogs.title')}
				path="/settings/integrations/sso/logs"
			/>
		</Tabs.Container>
	);
}

function Integrations() {
	const { t } = useTranslation();

	return (
		<>
			<Jumbo
				title={t('settings.integrations.title')}
				description={t('settings.integrations.description')}
				footer={<IntegrationsTabs />}
			/>
			<Switch>
				<Route path="/settings/integrations" exact>
					<Marketplace />
				</Route>
				<Route path="/settings/integrations/logs" exact>
					<ConnectorLogsContainer />
				</Route>
				<Route path="/settings/integrations/employes">
					<Employes />
				</Route>
				<Route path="/settings/integrations/nmbrs">
					<Nmbrs />
				</Route>
				<Route path="/settings/integrations/loket">
					<Loket />
				</Route>
				<Route path="/settings/integrations/afas">
					<Afas />
				</Route>
				<Route path="/settings/integrations/styr">
					<Styr />
				</Route>
				<Route path="/settings/integrations/goodhabitz">
					<GoodHabitz />
				</Route>
				<Route path="/settings/integrations/cobra">
					<SDWorx />
				</Route>
				<Route path="/settings/integrations/hooray">
					<Hooray />
				</Route>
				<Route path="/settings/integrations/slack">
					<Slack />
				</Route>
				<Route path="/settings/integrations/microsoft">
					<Microsoft />
				</Route>
				<Route path="/settings/integrations/youserve">
					<YouServe />
				</Route>
				<Route path="/settings/integrations/youforce">
					<YouForce />
				</Route>
				<Route path="/settings/integrations/hr2day">
					<HR2Day />
				</Route>
				<Route path="/settings/integrations/vismahrm">
					<VismaHRM />
				</Route>
				<Route path="/settings/integrations/scim">
					<Scim />
				</Route>
				<Route path="/settings/integrations/mcp">
					<McpRemote />
				</Route>
				<Route path="/settings/integrations/graphql-api">
					<GraphqlApi />
				</Route>
			</Switch>
		</>
	);
}

export default function Connectors() {
	return (
		<Switch>
			<Route path="/settings/integrations/sso">
				<SSOSettings />
			</Route>
			<Route path="/settings/integrations/:connectorId/migration" exact>
				<ConnectorMigrationTool />
			</Route>
			<Route path="/settings/integrations">
				<Integrations />
			</Route>
		</Switch>
	);
}
